<div class="unsubscribe-page">
  <div class="unsubscribe-card">
    <ng-container *ngIf="pageState === 'form'">
      <div class="intro-section">
        <div class="mail-icon">
          <svg class="mail-svg">
            <use xlink:href="./assets/img/sprite.svg#unsubscribemail"></use>
          </svg>
          <span class="mail-cross">
            <svg>
              <use xlink:href="./assets/img/sprite.svg#unsubscribecross"></use>
            </svg>
          </span>
        </div>
        <h2>Unsubscribe from<br>email communications</h2>
        <p>
          We're sorry to see you go. Please let us know why
          you're unsubscribing so we can improve our emails.
        </p>
      </div>

      <div class="form-section">
        <h2>Why are you unsubscribing?</h2>
        <p class="subtitle">
          Your feedback helps us improve our content and reduce unwanted emails.
        </p>
        <form [formGroup]="unsubscribeForm">
          <label
            class="reason-option"
            *ngFor="let reason of reasons; let i = index"
            [for]="'reason_' + i"
          >
            <input
              type="radio"
              name="unsubscribeReason"
              [id]="'reason_' + i"
              [value]="reason"
              [checked]="selectedReason === reason"
              (change)="selectReason(reason)"
            >
            <span>{{ reason }}</span>
          </label>

          <div class="reason-error" *ngIf="submitted && !selectedReason">
            Please select a reason.
          </div>

          <textarea
            *ngIf="selectedReason === 'Other'"
            formControlName="otherReason"
            placeholder="Please tell us the reason (optional)"
          ></textarea>

          <div class="privacy-text">
            <svg class="privacy-lock">
              <use xlink:href="./assets/img/sprite.svg#unsubscribelock"></use>
            </svg>
            <span>
              We respect your privacy. Your email communication
              preference will be updated.
            </span>
          </div>

          <div class="actions">
            <button
              type="button"
              class="unsubscribe-btn"
              [disabled]="loading"
              (click)="unsubscribe()"
            >
              {{ loading ? 'Please wait...' : 'Unsubscribe' }}
            </button>
          </div>
        </form>
      </div>
    </ng-container>

    <ng-container *ngIf="pageState === 'unsubscribed' || pageState === 'alreadyUnsubscribed'">
      <div class="result-section">
        <div class="success-icon">
          <svg>
            <use xlink:href="./assets/img/sprite.svg#unsubscribecheck"></use>
          </svg>
        </div>
        <h1>
          {{ pageState === 'alreadyUnsubscribed'
            ? 'You are already unsubscribed.'
            : 'You are unsubscribed.' }}
        </h1>
        <p>
          You have been successfully unsubscribed from our
          email communications.
        </p>
        <div class="divider"></div>
        <p>
          If this was a mistake or you change your mind,
          you can subscribe again below.
        </p>
        <button class="subscribe-btn" [disabled]="loading" (click)="subscribeAgain()">
          {{ loading ? 'Please wait...' : 'Subscribe Again' }}
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="pageState === 'subscribed'">
      <div class="result-section">
        <div class="success-icon">
          <svg>
            <use xlink:href="./assets/img/sprite.svg#unsubscribecheck"></use>
          </svg>
        </div>
        <h1>You're subscribed!</h1>
        <p>You will receive applicable email communications from us again.</p>
      </div>
    </ng-container>

    <ng-container *ngIf="pageState === 'invalid'">
      <div class="result-section">
        <div class="error-icon">!</div>
        <h1>Invalid unsubscribe link</h1>
        <p>This unsubscribe link is invalid or no longer available.</p>
      </div>
    </ng-container>

    <ng-container *ngIf="pageState === 'employee'">
      <div class="result-section">
        <div class="info-icon">i</div>
        <h1>Unsubscribe unavailable</h1>
        <p>This contact is not eligible to unsubscribe from these communications.</p>
      </div>
    </ng-container>
  </div>
</div>